import styled from '@emotion/styled';
import React from 'react';
import { Tooltip, Typography } from 'antd';
import { ProductOrders } from '../../../../repository/mytm/shop-product/shopProductRepository';

interface ProductNameColumnProps {
  product: ProductOrders;
}

export default React.memo((props: ProductNameColumnProps) => {
  const { product } = props;

  return (
    <StyledProductContainer>
      {product && product?.image ? (
        <div className="image" style={{ backgroundImage: `url('${product?.image}')` }} />
      ) : (
        <div className="image" />
      )}
      <Tooltip placement="top" title={product.productName}>
        <Typography.Text className="card-name-tiles">{product.productName}</Typography.Text>
      </Tooltip>
    </StyledProductContainer>
  );
});
const StyledProductContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  .image {
    width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left !important;

  .ant-typography {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
